import * as React from "react";
import { PasswordDetalhe } from "./detalhe";
import { PasswordBottom } from "./bottom";

export const PasswordPage = () => {
  return (
    <React.Fragment>
      <PasswordDetalhe />
      <PasswordBottom />
    </React.Fragment>
  );
};
